import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { TileData, TradeableTileData, TradingTileData } from 'state/quotes/dashboard/model';

import { ResultPanel, SolveModeLabel, TileLayout } from './components';
import { Price } from './components/result/price';
import type { TileContentProps } from './Tile.common';

export const FrozenTile: FC<TileContentProps<TileData>> = ({ data, header, subHeader, footer }) => {
  const { formatMessage } = useIntl();

  return (
    <TileLayout header={header} subHeader={subHeader} footer={footer}>
      <ResultPanel
        color="secondary"
        solveModeLabel={<SolveModeLabel value={data.solveMode} size="normal" />}
        price={
          !hasSolveResult(data) ? (
            <>{formatMessage({ id: 'dashboard.quoting.frozen' })}</>
          ) : (
            <Price
              solveResult={data.solveResult}
              solveResultFormat={data.solveResultFormat}
              xMargin={data.xMargin}
              color="secondary"
            />
          )
        }
      />
    </TileLayout>
  );
};

FrozenTile.displayName = 'FrozenTile';

function hasSolveResult(tileData: TileData): tileData is TradingTileData | TradeableTileData {
  return isTrading(tileData) || isTradeable(tileData);
}

function isTrading(tileData: TileData): tileData is TradingTileData {
  return tileData.status === 'Trading';
}

function isTradeable(tileData: TileData): tileData is TradeableTileData {
  return tileData.status === 'Tradeable';
}
